import { Ref } from 'react'
import { Paper, PaperProps } from '@mui/material'

import { CHART_CARD_BACKGROUND, TILE_RADIUS_PX } from '@/common/constants'

/**
 * The surface a chart sits on. `elevation={0}` is deliberate: the theme's
 * MuiPaper override only draws its border at elevation 3, so opting out of that
 * elevation is what leaves the card borderless.
 */
const ChartCard = ({ children, sx, ref, ...props }: PaperProps & { ref?: Ref<HTMLDivElement> }) => (
  <Paper
    ref={ref}
    elevation={0}
    sx={[
      {
        // Roomier than `MetricTileCard`'s 16px: a stat tile is a small box of
        // text, while a chart card carries a header, a rule and a plot that all
        // need air around them.
        p: 3,
        width: '100%',
        backgroundColor: CHART_CARD_BACKGROUND,
        borderRadius: `${TILE_RADIUS_PX}px`,
      },
      ...(sx ? (Array.isArray(sx) ? sx : [sx]) : []),
    ]}
    {...props}
  >
    {children}
  </Paper>
)

ChartCard.displayName = 'ChartCard'

export default ChartCard
